<div class="slider-list">
  <app-slider
    #slider
    [collection]="collection"
    [renderWithZeroItems]="true"
    [title]="list.name"
    [items]="records"
    [featured]="true"
    [preview]="true"
    [placeholder]="loading"
    [showActions]="true"
    [showSubheader]="true"
    [indentTop]="false"
    [showEmptyBoard]="showEmptyBoard"
    [extraHeaderMargin]="false"
    [loadedView]="'USER_LISTS'"
    (titleClicked)="showList()">
    <ng-template appSliderActions>
      <div class="actions-wrapper">
        <button mat-flat-button class="only-icon hide-tablet" (click)="showList()">
          <span class="odilo-icon">navigate_next</span>
        </button>
        <button mat-flat-button class="accent transparent hide-mobile" (click)="showList()">
          {{ 'common.viewMore' | translate }}
        </button>
        <button
          mat-flat-button
          class="only-icon"
          [matMenuTriggerFor]="actionsMenu"
          [attr.aria-label]="'common.viewMore' | translate">
          <span class="odilo-icon">more_vertical</span>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <button *ngIf="forListSubscriptions" mat-menu-item (click)="unfollowList()">
            <span class="odilo-icon">unfollow</span>
            {{ 'lists.unfollow' | translate }}
          </button>
          <button *ngIf="!forListSubscriptions" mat-menu-item (click)="editList()">
            <span class="odilo-icon">edit</span>
            {{ 'common.edit' | translate }}
          </button>
          <button *ngIf="!forListSubscriptions" mat-menu-item (click)="addTitles()">
            <span class="odilo-icon">add</span>
            {{ 'lists.addTitles' | translate }}
          </button>
          <button *ngIf="!list?.privateList" mat-menu-item (click)="copyToClipboard()">
            <span class="odilo-icon">link</span>
            {{ 'tooltip.copyLink' | translate }}
          </button>
          <button *ngIf="!forListSubscriptions" mat-menu-item (click)="showDeleteListDialog.set(true)">
            <span class="odilo-icon">delete</span>
            {{ 'lists.remove' | translate }}
          </button>
        </mat-menu>
      </div>
    </ng-template>

    <ng-template appSliderSubheader>
      <span class="header-subtitle">
        <span *ngIf="!forListSubscriptions">{{ (list.privateList ? 'lists.private' : 'lists.public') | translate }} · </span>
        <span>{{ list?.items.length }} {{ (list?.items.length === 1 ? "common.item" : "common.items") | translate }}</span> 
        <span *ngIf="!list.privateList" class="list-followers">
          <opac-icon icon="follower"></opac-icon>
          {{ list.followers }} {{ (list.followers === 1 ? "lists.follower" : "lists.followers") | translate }}
        </span>
      </span>
    </ng-template>
  </app-slider>

  <opac-no-results-cta *ngIf="showEmptyBoard">
    {{ 'lists.noElements' | translate }}
    <opac-button *ngIf="!forListSubscriptions" type="secondary" (click)="addTitles()"> {{ 'lists.addElements' | translate }} </opac-button>
  </opac-no-results-cta>
</div>

<opac-confirmation-dialog
  [acceptLabel]="'common.delete'"
  [open]="showDeleteListDialog()"
  [title]="'lists.empty.confirm.title' | translate"
  (accept)="deleteList()"
  (cancel)="showDeleteListDialog.set(false)">
  <p [innerHTML]="descriptionToDeleteListDialog() | translate"></p>
</opac-confirmation-dialog>
